// 在庫1点の商品は数量ボタンを非表示にする
async function hideQuantityButtonsForSingleStock() {
  const inputs = document.querySelectorAll('.cart-quantity .quantity__input[data-quantity-variant-id]');
  
  for (const input of inputs) {
    const variantId = input.dataset.quantityVariantId;
    
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const variant = await res.json();
      
      if (variant.inventory_management && variant.inventory_quantity <= 1) {
        const wrapper = input.closest('quantity-input');
        wrapper.querySelectorAll('.quantity__button').forEach(btn => {
          btn.style.display = 'none';
        });
        input.setAttribute('readonly', true);
        input.style.textAlign = 'center';
      }
    } catch (e) {
      console.warn('在庫確認エラー:', variantId, e);
    }
  }
}

document.addEventListener('DOMContentLoaded', hideQuantityButtonsForSingleStock);
